import { Component, Inject, Input, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { SidebarNavHelper } from '../app-sidebar-nav.service';
import { INavData } from '../app-sidebar-nav';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';

@Component({
    selector: 'app-sidebar-nav-items, cui-sidebar-nav-items',
    template: `
    <ng-container *ngFor="let item of items">
      <ng-container [ngSwitch]="helper.itemType(item)">
      <ng-container *ngIf="item.children && item.children.length != undefined && item.children.length > 0">
       <app-sidebar-nav-dropdown
          *ngSwitchCase="'dropdown'"
          [item]="item"
          [class.open]="helper.isActiveCustom(router, item) || item.open != undefined"
          [ngClass]="item | appSidebarNavItemClass"
          appNavDropdown
         >
        </app-sidebar-nav-dropdown>
        </ng-container>
        <app-sidebar-nav-divider
          *ngSwitchCase="'divider'"
          [item]="item"
          [ngClass]="item | appSidebarNavItemClass"
          [appHtmlAttr]="item.attributes">
        </app-sidebar-nav-divider>
        <app-sidebar-nav-title
          *ngSwitchCase="'title'"
          [item]="item"
          [ngClass]="item | appSidebarNavItemClass"
          [appHtmlAttr]="item.attributes">
        </app-sidebar-nav-title>
        <app-sidebar-nav-label
          *ngSwitchCase="'label'"
          [item]="item"
          class="nav-item"
          [ngClass]="item | appSidebarNavItemClass">
        </app-sidebar-nav-label>
        <ng-container
          *ngSwitchCase="'empty'">
        </ng-container>
        <app-sidebar-nav-link
          *ngSwitchDefault
          [item]="item"
          class="nav-item"
          [ngClass]="item | appSidebarNavItemClass"
          (linkClick)="hideMobile()"
        >
        </app-sidebar-nav-link>
      </ng-container>
    </ng-container>
  `,
    standalone: false
})
export class AppSidebarNavItemsComponent {

  protected _items: INavData[];
  @Input()
  set items(items: INavData[]) {
    this._items = [...items];
  }
  get items(): INavData[] {
    return this._items;
  }

  constructor(
    @Inject(DOCUMENT) private document: any,
    private renderer: Renderer2,
    public router: Router,
    public helper: SidebarNavHelper,
    public appService: AppService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private elRef: ElementRef

  ) {
    appService.setApplication(this.activatedRoute.snapshot.data.application);
  }

  getLink(item: INavData): string | any[] {
    return this.router.url.split('?')[0];
  }

  public hideMobile() {
    if (this.document.body.classList.contains('sidebar-show')) {
      this.renderer.removeClass(this.document.body, 'sidebar-show');
      this.appService.sideBarOpen(false);
      // this.appService.showSidebar = false;
    }
    //removing stored filter after click as not needed
    try {
      let res = localStorage.getItem('CurrentResource');
        this.storageService.removeData('filterConfig' +res, () => { });
        this.storageService.removeData('filterFormMapping' + res, () => { });
    } catch (error) { }
  }
}
